module.exports = __webpack_public_path__ + "img/project_icno3.85603b67.png";